// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root layout */
.dc-root-row {
    flex: 1 1;
    min-height: 0;
    height: 100%;
    overflow: hidden;
}

/* Left column */
.dc-left-col {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.dc-left-wrap {
    position: relative;
    flex: 1 1;
    min-height: 0;
}

/* AI link (κάτω-αριστερά) */
.dc-ai-link {
    position: absolute;
    left: 18px;
    bottom: 20px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    opacity: 0.9;
    color: #7E22CE;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.dc-ai-badge {
    display: inline-block;
    background: #111827;
    /* βάψε το #7E22CE αν προτιμάς */
    color: #fff;
    font-size: 11px;
    font-weight: 800;
    border-radius: 4px;
    padding: 2px 5px;
    line-height: 1;
}

/* Right column */
.dc-right-col {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    visibility: hidden;
    /* default */
}

.dc-right-col.is-visible {
    visibility: visible;
}

.dc-right-col.is-hidden {
    visibility: hidden;
}

/* Skills wrapper (dynamic height via inline style μόνο) */
.dc-skills-wrap {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.dc-skills-row {
    min-height: 0;
    flex: 1 1;
}

.dc-col-flex {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

/* Separator */
.dc-separator {
    margin-top: 6px;
    margin-bottom: 6px;
}

/* Buttons block */
.dc-buttons {
    flex-shrink: 0;
}

/* Status box (read-only mode) */
.dc-status-box {
    padding: 8px 8px;
    border-radius: 12px;
    background: #E5E7EB;
    border: 1px solid #bbbbbb;
    color: #374151;
    display: flex;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    min-height: 60px;
    font-size: 12px;
    font-weight: 500;
}

.dc-status-strong {
    font-size: 12px;
    font-weight: 800;
    color: #111827;
}

/* Toast */
.dc-toast {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 9999;
    background: #111827;
    color: #fff;
    padding: 10px 14px;
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, .25);
    font-size: 13px;
    max-width: 360px;
}

/* Utilities */
.dc-error {
    margin-top: 12px;
    color: #dc2626;
    text-align: center;
    font-size: 14px;
}

.dc-pad {
    padding: 1rem;
}

/* ===== RecommendedSkillsPanel ===== */
.rsp-root-row {
    height: 100%;
    min-height: 0;
}

.rsp-content-row {
    height: 100%;
    min-height: 0;
}

.rsp-content-row.has-label {
    height: calc(100% - 28px);
    /* χώρο για το label */
}

/* Κοινό box για skills panels */
.dc-box {
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.dc-box--skills {
    padding: 10px;
}

/* Input ύψος/συμπεριφορά */
.dc-input {
    flex: 0 0 38px;
    min-height: 38px;
}

/* Scroll area (δυναμικό ύψος με CSS var) */
.rsp-list {
    height: var(--list-h);
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* Action link στο κάτω μέρος */
.dc-action {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 8px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    text-align: left;
    color: #7E22CE;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

/* Reuse από πριν – μικρό badge ως “AI icon” */
.dc-ai-badge {
    display: inline-block;
    background: #111827;
    /* βάψ’ το #7E22CE αν προτιμάς μοβ */
    color: #fff;
    font-size: 11px;
    font-weight: 800;
    border-radius: 4px;
    padding: 2px 5px;
    line-height: 1;
}

/* ===== Responsive tweaks ===== */

/* Σε μικρότερες οθόνες (κάτω από 768px) */
@media (max-width: 767px) {
    .dc-root-row {
        flex-direction: column;
        height: auto;
    }

    .dc-left-col,
    .dc-right-col {
        width: 100%;
        max-width: 100%;
        flex: 1 1 auto;
        min-height: 0;
    }

    /* Κάνε τα κουτιά να έχουν λίγο margin ανάμεσα */
    .dc-left-wrap,
    .dc-skills-wrap {
        margin-bottom: 16px;
    }

    /* Input και κουμπιά 100% */
    .dc-input {
        width: 100%;
    }

    .dc-buttons button {
        width: 100%;
        margin-bottom: 8px;
    }
}

/* Σε πολύ μικρές οθόνες (κάτω από 480px) */
@media (max-width: 480px) {

    .dc-ai-link,
    .dc-action {
        font-size: 12px;
        gap: 4px;
    }

    .dc-ai-badge {
        font-size: 10px;
        padding: 2px 4px;
    }

    .description-labels {
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Description/description-card.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,0DAA0D;AAC1D;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,yCAAyC;IACzC,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,uCAAuC;AACvC;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,8CAA8C;AAC9C;IACI,qBAAqB;IACrB,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,kCAAkC;;AAElC,0CAA0C;AAC1C;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,eAAe;QACf,cAAc;QACd,aAAa;IACjB;;IAEA,gDAAgD;IAChD;;QAEI,mBAAmB;IACvB;;IAEA,2BAA2B;IAC3B;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,2CAA2C;AAC3C;;IAEI;;QAEI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Root layout */\n.dc-root-row {\n    flex: 1;\n    min-height: 0;\n    height: 100%;\n    overflow: hidden;\n}\n\n/* Left column */\n.dc-left-col {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.dc-left-wrap {\n    position: relative;\n    flex: 1;\n    min-height: 0;\n}\n\n/* AI link (κάτω-αριστερά) */\n.dc-ai-link {\n    position: absolute;\n    left: 18px;\n    bottom: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.2;\n    cursor: pointer;\n    user-select: none;\n    opacity: 0.9;\n    color: #7E22CE;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.dc-ai-badge {\n    display: inline-block;\n    background: #111827;\n    /* βάψε το #7E22CE αν προτιμάς */\n    color: #fff;\n    font-size: 11px;\n    font-weight: 800;\n    border-radius: 4px;\n    padding: 2px 5px;\n    line-height: 1;\n}\n\n/* Right column */\n.dc-right-col {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n    visibility: hidden;\n    /* default */\n}\n\n.dc-right-col.is-visible {\n    visibility: visible;\n}\n\n.dc-right-col.is-hidden {\n    visibility: hidden;\n}\n\n/* Skills wrapper (dynamic height via inline style μόνο) */\n.dc-skills-wrap {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.dc-skills-row {\n    min-height: 0;\n    flex: 1;\n}\n\n.dc-col-flex {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n/* Separator */\n.dc-separator {\n    margin-top: 6px;\n    margin-bottom: 6px;\n}\n\n/* Buttons block */\n.dc-buttons {\n    flex-shrink: 0;\n}\n\n/* Status box (read-only mode) */\n.dc-status-box {\n    padding: 8px 8px;\n    border-radius: 12px;\n    background: #E5E7EB;\n    border: 1px solid #bbbbbb;\n    color: #374151;\n    display: flex;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 8px;\n    min-height: 60px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.dc-status-strong {\n    font-size: 12px;\n    font-weight: 800;\n    color: #111827;\n}\n\n/* Toast */\n.dc-toast {\n    position: fixed;\n    bottom: 16px;\n    right: 16px;\n    z-index: 9999;\n    background: #111827;\n    color: #fff;\n    padding: 10px 14px;\n    border-radius: 10px;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, .25);\n    font-size: 13px;\n    max-width: 360px;\n}\n\n/* Utilities */\n.dc-error {\n    margin-top: 12px;\n    color: #dc2626;\n    text-align: center;\n    font-size: 14px;\n}\n\n.dc-pad {\n    padding: 1rem;\n}\n\n/* ===== RecommendedSkillsPanel ===== */\n.rsp-root-row {\n    height: 100%;\n    min-height: 0;\n}\n\n.rsp-content-row {\n    height: 100%;\n    min-height: 0;\n}\n\n.rsp-content-row.has-label {\n    height: calc(100% - 28px);\n    /* χώρο για το label */\n}\n\n/* Κοινό box για skills panels */\n.dc-box {\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.dc-box--skills {\n    padding: 10px;\n}\n\n/* Input ύψος/συμπεριφορά */\n.dc-input {\n    flex: 0 0 38px;\n    min-height: 38px;\n}\n\n/* Scroll area (δυναμικό ύψος με CSS var) */\n.rsp-list {\n    height: var(--list-h);\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n/* Action link στο κάτω μέρος */\n.dc-action {\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.2;\n    margin-top: 8px;\n    cursor: pointer;\n    user-select: none;\n    text-align: left;\n    color: #7E22CE;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n/* Reuse από πριν – μικρό badge ως “AI icon” */\n.dc-ai-badge {\n    display: inline-block;\n    background: #111827;\n    /* βάψ’ το #7E22CE αν προτιμάς μοβ */\n    color: #fff;\n    font-size: 11px;\n    font-weight: 800;\n    border-radius: 4px;\n    padding: 2px 5px;\n    line-height: 1;\n}\n\n/* ===== Responsive tweaks ===== */\n\n/* Σε μικρότερες οθόνες (κάτω από 768px) */\n@media (max-width: 767px) {\n    .dc-root-row {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .dc-left-col,\n    .dc-right-col {\n        width: 100%;\n        max-width: 100%;\n        flex: 1 1 auto;\n        min-height: 0;\n    }\n\n    /* Κάνε τα κουτιά να έχουν λίγο margin ανάμεσα */\n    .dc-left-wrap,\n    .dc-skills-wrap {\n        margin-bottom: 16px;\n    }\n\n    /* Input και κουμπιά 100% */\n    .dc-input {\n        width: 100%;\n    }\n\n    .dc-buttons button {\n        width: 100%;\n        margin-bottom: 8px;\n    }\n}\n\n/* Σε πολύ μικρές οθόνες (κάτω από 480px) */\n@media (max-width: 480px) {\n\n    .dc-ai-link,\n    .dc-action {\n        font-size: 12px;\n        gap: 4px;\n    }\n\n    .dc-ai-badge {\n        font-size: 10px;\n        padding: 2px 4px;\n    }\n\n    .description-labels {\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
